import { type ReactElement } from 'react';
import { Button } from '@/components/atoms/button';

export function RecoveryFallback(): ReactElement {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--bg-page)] px-6 text-center"
    >
      <h1 className="font-display text-[28px] font-semibold tracking-tight text-[var(--ink)]">
        Something went wrong
      </h1>
      <p className="max-w-[360px] text-sm text-[var(--ink-3)]">
        The page hit an error it couldn't recover from. Reloading usually fixes it.
      </p>
      <Button onClick={() => window.location.reload()}>Reload page</Button>
    </div>
  );
}
